import { render, staticRenderFns } from "./FolderSelector.vue?vue&type=template&id=52c3c23d&scoped=true&"
import script from "./FolderSelector.vue?vue&type=script&lang=js&"
export * from "./FolderSelector.vue?vue&type=script&lang=js&"
import style0 from "./FolderSelector.vue?vue&type=style&index=0&id=52c3c23d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c3c23d",
  null
  
)

export default component.exports